import { logger } from "../../analytics/logger";
import { AcceleratorTypeWireFormat3 } from "../../generated/kernels";
import { ModelFramework } from "../../generated/models";
import { parseTimestamp } from "./common";
export var parseActiveEventFromDocument = function(doc) {
    var session = doc.get("kernelSession");
    var schedule = doc.get("scheduledKernelSession");
    var dataset = doc.get("datasetUpload");
    var submission = doc.get("competitionSubmission");
    var validation = doc.get("competitionMetricValidation");
    var model = doc.get("modelUpload");
    if (session) {
        return {
            id: doc.id,
            eventStart: parseTimestamp(doc.get("eventStart")),
            eventEnd: parseTimestamp(doc.get("eventEnd")),
            stepStart: parseTimestamp(doc.get("stepStart")),
            kernelSessionActiveEvent: {
                sessionId: session.sessionId,
                kernelId: session.kernelId,
                title: session.title,
                workerStatus: parseWorkerStatus(session.workerStatus),
                type: parseKernelSessionExecutionType(session.type),
                acceleratorType: parseAcceleratorType(Number(session.acceleratorType)),
                versionNumber: session.versionNumber || 1
            }
        };
    } else if (schedule) {
        return {
            id: doc.id,
            eventStart: parseTimestamp(doc.get("eventStart")),
            eventEnd: parseTimestamp(doc.get("eventEnd")),
            stepStart: parseTimestamp(doc.get("stepStart")),
            scheduledKernelSessionActiveEvent: {
                scheduledKernelSessionId: schedule.scheduledKernelSessionId,
                kernelId: schedule.kernelId,
                title: schedule.title,
                iteration: schedule.iteration,
                iterations: schedule.iterations,
                nextSessionDate: parseTimestamp(schedule.nextSessionDate)
            }
        };
    } else if (dataset) {
        return {
            id: doc.id,
            eventStart: parseTimestamp(doc.get("eventStart")),
            eventEnd: parseTimestamp(doc.get("eventEnd")),
            stepStart: parseTimestamp(doc.get("stepStart")),
            datasetUploadActiveEvent: {
                datasetId: dataset.datasetId,
                datasetVersionId: dataset.datasetVersionId,
                title: dataset.title,
                url: dataset.url,
                thumbnailImage: dataset.thumbnailImage,
                versionNotes: dataset.versionNotes,
                percentDone: dataset.percentDone,
                errorMessage: dataset.errorMessage,
                status: parseDatasetUploadStatus(dataset.status),
                type: parseDatasetUploadType(dataset.type)
            }
        };
    } else if (model) {
        return {
            id: doc.id,
            eventStart: parseTimestamp(doc.get("eventStart")),
            eventEnd: parseTimestamp(doc.get("eventEnd")),
            stepStart: parseTimestamp(doc.get("stepStart")),
            modelUploadActiveEvent: {
                modelId: model.modelId,
                modelInstanceVersionId: model.modelInstanceVersionId,
                title: model.title,
                framework: parseFramework(model.framework),
                variationSlug: model.variationSlug,
                url: model.url,
                versionNotes: model.versionNotes,
                percentDone: model.percentDone,
                errorMessage: model.errorMessage,
                status: parseModelUploadStatus(model.status),
                type: parseModelUploadType(model.type)
            }
        };
    } else if (submission) {
        return {
            id: doc.id,
            eventStart: parseTimestamp(doc.get("eventStart")),
            eventEnd: parseTimestamp(doc.get("eventEnd")),
            stepStart: parseTimestamp(doc.get("stepStart")),
            competitionSubmissionActiveEvent: {
                submissionId: submission.submissionId,
                kernelSessionId: submission.kernelSessionId,
                url: submission.url,
                competitionId: submission.competitionId,
                competitionTitle: submission.competitionTitle,
                competitionThumbnailImageUrl: submission.competitionThumbnailImageUrl,
                status: parseCompetitionSubmissionStatus(submission.status),
                errorType: parseCompetitionSubmissionErrorType(submission.errorType),
                errorDetails: submission.errorDetails
            }
        };
    } else if (validation) {
        return {
            id: doc.id,
            eventStart: parseTimestamp(doc.get("eventStart")),
            eventEnd: parseTimestamp(doc.get("eventEnd")),
            stepStart: parseTimestamp(doc.get("stepStart")),
            competitionMetricValidationActiveEvent: {
                competitionMetricVersionId: validation.competitionMetricVersionId,
                sourceKernelSessionId: validation.sourceKernelSessionId,
                metricName: validation.metricName,
                isValid: validation.isValid,
                errorMessage: validation.errorMessage
            }
        };
    }
    logger.report("navigation", "active-events-parse-unknown");
    return null;
};
var parseWorkerStatus = function(status) {
    // C# Enum: https://github.com/Kaggle/kaggleazure/blob/ci/Kaggle.Sdk/Kernels/Models/KernelWorkerStatus.cs
    switch(status){
        case 0:
            return "queued";
        case 1:
            return "running";
        case 2:
            return "complete";
        case 3:
            return "error";
        case 4:
            return "cancelRequested";
        case 5:
            return "cancelAcknowledged";
        default:
            return "unknown";
    }
};
var parseKernelSessionExecutionType = function(status) {
    // Proto enum: https://github.com/Kaggle/kaggleazure/blob/ci/Kaggle.Sdk/ActiveEvents/Protos/active_event.proto
    switch(status){
        case 1:
            return "interactive";
        case 2:
            return "batch";
        default:
            return "unknown";
    }
};
var parseAcceleratorType = function(status) {
    return AcceleratorTypeWireFormat3.fromJson(AcceleratorTypeWireFormat3.toJson(status));
};
var parseDatasetUploadType = function(type) {
    // Proto enum: https://github.com/Kaggle/kaggleazure/blob/ci/Kaggle.Sdk/ActiveEvents/Protos/active_event.proto
    switch(type){
        case 1:
            return "creation";
        case 2:
            return "version";
        default:
            return "unknown";
    }
};
var parseDatasetUploadStatus = function(status) {
    // Proto enum: https://github.com/Kaggle/kaggleazure/blob/ci/Kaggle.Sdk/ActiveEvents/Protos/active_event.proto
    switch(status){
        case 1:
            return "creating";
        case 2:
            return "finished";
        case 3:
            return "failed";
        default:
            return "unknown";
    }
};
var parseModelUploadType = function(type) {
    // Proto enum: https://github.com/Kaggle/kaggleazure/blob/ci/Kaggle.Sdk/ActiveEvents/Protos/active_event.proto
    switch(type){
        case 1:
            return "newInstance";
        case 2:
            return "newVersion";
        default:
            return "unknown";
    }
};
var parseModelUploadStatus = function(status) {
    // Proto enum: https://github.com/Kaggle/kaggleazure/blob/ci/Kaggle.Sdk/ActiveEvents/Protos/active_event.proto
    switch(status){
        case 1:
            return "creating";
        case 2:
            return "finished";
        case 3:
            return "failed";
        default:
            return "unknown";
    }
};
var parseFramework = function(framework) {
    switch(framework){
        case 1:
            return ModelFramework.TENSOR_FLOW_1;
        case 2:
            return ModelFramework.TENSOR_FLOW_2;
        case 3:
            return ModelFramework.TF_LITE;
        case 4:
            return ModelFramework.TF_JS;
        case 5:
            return ModelFramework.PY_TORCH;
        case 6:
            return ModelFramework.JAX;
        case 7:
            return ModelFramework.CORAL;
        case 8:
            return ModelFramework.SCIKIT_LEARN;
        case 9:
            return ModelFramework.MXNET;
        case 10:
            return ModelFramework.ONNX;
        default:
            return ModelFramework.UNSPECIFIED;
    }
};
var parseCompetitionSubmissionStatus = function(status) {
    // Proto enum: https://github.com/Kaggle/kaggleazure/blob/ci/Kaggle.Sdk/ActiveEvents/Protos/active_event.proto
    switch(status){
        case 0:
            return "pending";
        case 1:
            return "complete";
        case 2:
            return "error";
        default:
            return "unknown";
    }
};
var parseCompetitionSubmissionErrorType = function(errorType) {
    // Proto enum: https://github.com/Kaggle/kaggleazure/blob/ci/Kaggle.Sdk/ActiveEvents/Protos/active_event.proto
    switch(errorType){
        case 0:
            return "submissionErrorTypeUnspecified";
        case 1:
            return "submissionFileNotFound";
        case 2:
            return "submissionLimitExceeded";
        default:
            return "unknown";
    }
};
